import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Pagination } from "react-bootstrap";

export const formatServiceOrderNumber = (serviceOrderNumber) => {
  if (typeof serviceOrderNumber !== "string") {
    return serviceOrderNumber || "";
  }

  return serviceOrderNumber.startsWith("CTS")
    ? `BD${serviceOrderNumber.slice(3)}`
    : serviceOrderNumber;
};

const CpapTrialTicketItem = ({
  tickets,
  onEdit,
  onDelete,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  onViewFile,
  onExportTicket,
  onExternalRepair,
  goToPage,
  isStart,
  isEnd,
  getNext,
  getPrev,
}) => {
  const [loading, setLoading] = useState(false);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table mb-0 table-striped">
                  <thead>
                    <tr>
                      <th></th>
                      <th>No.</th>
                      <th>HN</th>
                      <th>Brand</th>
                      <th>Model</th>
                      <th>Type</th>
                      <th>SN</th>
                      <th>Service Type</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody id="cpap-trial-service-tickets-table">
                    {!loading ? (
                      tickets.map((item, index) => {
                        var variantActivity = "";
                        if (item.serviceStatus === "รับเครื่อง") {
                          variantActivity = "info dark";
                        } else if (item.serviceStatus === "กำลังตรวจเช็ค") {
                          variantActivity = "info light";
                        } else if (item.serviceStatus === "รออะไหล่") {
                          variantActivity = "warning light";
                        } else if (item.serviceStatus === "กำลังดำเนินการ") {
                          variantActivity = "info light";
                        } else if (item.serviceStatus === "ส่งซ่อมบริษัทนอก") {
                          variantActivity = "warning light";
                        } else if (item.serviceStatus === "เสร็จสิ้น") {
                          variantActivity = "success light";
                        } else if (item.serviceStatus === "ยกเลิก") {
                          variantActivity = "danger light";
                        }
                        return (
                          <tr key={item.id} className="btn-reveal-trigger">
                            <td className="py-1">
                              {index + 1 + (currentPage - 1) * itemsPerPage}
                            </td>
                            <td className="py-2">
                              {formatServiceOrderNumber(item.serviceOrderNumber)}
                            </td>
                            <td className="py-2">
                              {item.hn}
                            </td>
                            <td className="py-2">{item.brand}</td>
                            <td className="py-2">{item.model}</td>
                            <td className="py-2">{item.cpapType}</td>
                            <td className="py-2">
                              <Link
                                to={"/cpap-page/" + item.sn}
                                data-toggle="tooltip"
                                data-placement="top"
                                title={item.sn}
                              >
                                {item.sn}
                              </Link>
                            </td>
                            <td className="py-2">{item.serviceType}</td>
                            <td className="py-2">
                              <Badge variant={variantActivity}>
                                {item.serviceStatus}
                              </Badge>
                            </td>
                            <td className="py-2 text-right">
                              <div className="d-flex">
                                <Link
                                  className="btn btn-primary shadow btn-xs sharp mr-2"
                                  to="#"
                                  onClick={() => onExportTicket && onExportTicket(item.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Export Service Ticket Form"
                                >
                                  <i className="fa fa-file-pdf-o"></i>
                                </Link>
                                <Link
                                  className="btn btn-info shadow btn-xs sharp mr-2"
                                  to="#"
                                  onClick={() => onEdit(item.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Edit service ticket"
                                >
                                  <i className="fa fa-pencil"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-warning shadow btn-xs sharp mr-2"
                                  onClick={() =>
                                    onExternalRepair && onExternalRepair(item.id)
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Send to External Repair"
                                >
                                  <i className="fa fa-truck"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => onDelete(item.id, item.image)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Delete service ticket"
                                >
                                  <i className="fa fa-trash"></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden"></span>
                          </div>
                        </td>
                      </tr>
                    )}
                    {!loading && tickets.length === 0 && (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No maintenance tickets found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {totalItems < currentPage * itemsPerPage
                    ? totalItems
                    : currentPage * itemsPerPage}{" "}
                  of {totalItems} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <Pagination
                    className="pagination-primary pagination-circle"
                    size="lg"
                  >
                    <Pagination.Prev onClick={getPrev} disabled={isStart} />
                    {pageNumbers.map((number) => (
                      <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => goToPage(number)}
                      >
                        {number}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={getNext} disabled={isEnd} />
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CpapTrialTicketItem;
